<p *ngIf="!failedSignIn" translate>
    SIGNING_IN
</p>
<div *ngIf="failedSignIn">
  <h1 translate>FAILED_TO_LOG_IN</h1>
</div>
